// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__7bVbi","header":"styles_header__mp0uN","bannerText":"styles_bannerText__gxV8s"};